import { $api } from "@/services/api";

export default function useFormHelpers(): any {
  function months(): any[] {
    return Array.from({ length: 12 }, (item, i) => {
      return {
        label: new Date(0, i).toLocaleString("en-US", { month: "long" }),
        value: i + 1, // Javascript starts months at 0
      };
    });
  }

  function years(future: boolean): any[] {
    const current = new Date().getFullYear();
    const years: any[] = [{ label: current.toString(), value: current }];

    if (future) {
      for (let i = 1; i <= 10; i++) {
        years.push({ label: (current + i).toString(), value: current + i });
      }
    } else {
      for (let i = 1; i <= 100; i++) {
        years.push({ label: (current - i).toString(), value: current - i });
      }
    }

    return years;
  }

  function days(year = 0, month = 0): any[] {
    const days = [];
    const dayCount = new Date(year, month, 0).getDate();

    for (let i = 1; i <= dayCount; i++) {
      days.push({ label: i.toString(), value: i });
    }

    return days;
  }

  function phoneTypes(): any[] {
    return [
      {
        label: "Mobile",
        value: "MOBILE",
      },
      {
        label: "Work",
        value: "WORK",
      },
      {
        label: "Home",
        value: "PERM",
      },
      {
        label: "Temporary",
        value: "TEMP",
      },
    ];
  }

  function calculateAge(dateStr: string) {
    const dob = new Date(dateStr);
    if (dateStr !== null) {
      const response = $api.applicant.calculateApplicantAge(dob);
      return response;
    } else {
      return 0;
    }
  }

  function convertDateOfBirthToAge(dobInput: string) {
    const birthDate = new Date(dobInput);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Adjust age if the birthday hasn't happened yet this year
    // monthDiff < 0 indicates future months that have not happened yet
    // monthDiff === 0 && dayDiff <= 0 indicates future dates in the same month that havent happened yet
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff <= 0)) {
      age--;
    }

    // Check for leap year
    function isLeapYear(year: number) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // Adjust for leap year if the birthday is on February 29th
    if (
      birthDate.getMonth() === 1 &&
      birthDate.getDate() === 29 &&
      !isLeapYear(today.getFullYear())
    ) {
      age++; // Add one year if the current year is not a leap year
    }

    return age;
  }
	
  return { months, years, days, phoneTypes, calculateAge, convertDateOfBirthToAge };
}
